import { FormattedMessage } from 'react-intl';
import { AlertInfoIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';

export const NEW_RECORD = {
  noIncomePast30Days: '',
  noIncomeUtilities: '',
};

export const getDefaultValues = (item) => {
  return {
    id: item.id ?? '',
    noIncomePast30Days: item.noIncomePast30Days ?? '',
    noIncomeUtilities: item.noIncomeUtilities ?? '',
  };
};

export const MESSAGE_IDS = {
  title: 'afforda.wagesAndIncome.details.noIncome.title',
};

export const NO_INCOME_FIELD_NAMES = {
  noIncomePast30Days: 'noIncomePast30Days',
  noIncomeUtilities: 'noIncomeUtilities',
};

export const FIELDS = ({ intl }) => [
  {
    variant: 'number',
    label: (
      <FormattedMessage id="afforda.wagesAndIncome.details.noIncome.past30days" />
    ),
    name: NO_INCOME_FIELD_NAMES.noIncomePast30Days,
    InputLabelProps: {
      TooltipProps: {
        title: (
          <FormattedMessage id="afforda.wagesAndIncome.details.noIncome.past30days.tooltip" />
        ),
        children: <AlertInfoIcon fontSize={'small'} />,
      },
    },
    rules: {
      max: 499999.99,
      min: 1,
      step: 0.01,
      required: true,
    },
    adornment: '$',
    GridProps: {
      xs: 12,
    },
  },
  {
    variant: 'text',
    label: (
      <FormattedMessage id="afforda.wagesAndIncome.details.noIncome.fundsUtilities" />
    ),
    name: NO_INCOME_FIELD_NAMES.noIncomeUtilities,
    rules: {
      required: true,
    },
    placeholder: intl.formatMessage({
      id: 'afforda.wagesAndIncome.details.noIncome.sources',
    }),
    multiline: true,
    rows: 4,
    GridProps: {
      xs: 12,
    },
  },
];
